<template>
    <div class="preview-doc service-fee-pdf-preview-docs">
        <div style="display: flex; justify-content: space-between;">
            <div>
                <div class="company-name">{{ companyName }}</div>
                <div class="doc-title">{{ title }}</div>
            </div>
            <div style="width: 15%">
                <div class="text-line"></div>
                <div class="text-line"></div>
                <div class="text-line"></div>
                <div class="text-line"></div>
            </div>
        </div>
        <table cellspacing="0" cellpadding="0" class="info-table" style="margin-top: 12px">
            <tr>
                <th colspan="2">勞務內容</th>
                <th colspan="2">領款人</th>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
        </table>
        <table cellspacing="0" cellpadding="0" class="info-table">
            <tr>
                <th colspan="2">付款金額</th>
                <th colspan="2"></th>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
            <tr>
                <td class="label-cell"></td>
                <td></td>
                <td class="label-cell"></td>
                <td></td>
            </tr>
        </table>
        <div v-if="showSignArea" class="sign-area" style="margin-top: 20px;">
            <div><br/><br/><br/></div>
            <div>領款人:_________(簽名或蓋章) ____年____月____日</div>
        </div>
        <div v-if="showIdImage" class="id-image-area">
            <table cellspacing="0" cellpadding="0">
                <tr>
                    <th colspan="2">身分證(居留證/護照)影本黏貼處</th>
                </tr>
                <tr>
                    <td><div style="width: 100%; aspect-ratio: 2;"></div></td>
                    <td><div style="width: 100%; aspect-ratio: 2;"></div></td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'payment-export-pdf-dialog',
    props: {
        companyName: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '勞務報酬單',
        },
        showSignArea: {
            type: Boolean,
            default: true,
        },
        showIdImage: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {

        };
    },
};
</script>
<style lang="scss">
.service-fee-pdf-preview-docs {

    .sign-area {
        text-align: center;
        border: 1px solid #000;
        padding: 5px;
    }
    .id-image-area {
        margin-top: 10px;
    }

    table.info-table {
        border-left: 0 !important;
        border-right: 0 !important;
        text-align: left;
        margin-bottom: 10px;

        td, th {
            border-left: 0 !important;
            border-right: 0 !important;
            text-align: left;
            padding: 0 3px;
            height: 12px;

            @media (min-width: 600px) {
                height: 15px;
            }
            @media (min-width: 720px) {
                height: 12px;
            }
        }

        td {
            border-color: #ccc !important;
            width: 20%;
        }
        td.label-cell {
            background-color: #eee;
            border-color: #ccc;
            color: transparent;
            width: 20%;
        }
    }
}

</style>
